/* eslint-disable @typescript-eslint/no-var-requires */
const aws = require("./aws.svg");
const baseCase = require("./basecase.svg");
const calendar = require("./calendar.svg");
const chatTyping = require("./chatTyping.svg");
const compass = require("./compass.svg");
const computer = require("./computer.svg");
const conversation = require("./conversation.svg");
const github = require("./github.svg");
const house = require("./house.svg");
const kubernetes = require("./kubernetes.svg");
const linkedIn = require("./linkedIn.svg");
const money = require("./money.svg");
const northzone = require("./northzone.svg");
const notebook = require("./notebook.svg");
const notion = require("./notion.svg");
const paperPlane = require("./paperPlane.svg");
const play = require("./play.svg");
const prometheus = require("./prometheus.svg");
const reactJS = require("./reactJS.svg");
const rocker = require("./rocket.svg");
const rust = require("./rust.svg");
const smiley = require("./smiley.svg");
const study = require("./study.svg");
const systemOne = require("./systemone.svg");
const threePeople = require("./threePeople.svg");
const tokio = require("./tokio.svg");
const twitter = require("./twitter.svg");
const typescript = require("./typescript.svg");
const webAssembly = require("./webAssembly.svg");

export const Aws = aws;
export const BaseCase = baseCase;
export const Calendar = calendar;
export const ChatTyping = chatTyping;
export const Compass = compass;
export const Computer = computer;
export const Conversation = conversation;
export const GitHub = github;
export const House = house;
export const Kubernetes = kubernetes;
export const LinkedIn = linkedIn;
export const MoneyIcon = money;
export const Northzone = northzone;
export const Notebook = notebook;
export const Notion = notion;
export const PaperPlane = paperPlane;
export const Play = play;
export const Prometheus = prometheus;
export const ReactJS = reactJS;
export const Rocker = rocker;
export const Rust = rust;
export const Smiley = smiley;
export const Study = study;
export const SystemOne = systemOne;
export const ThreePeople = threePeople;
export const Tokio = tokio;
export const TwitterIcon = twitter;
export const Typescript = typescript;
export const WebAssembly = webAssembly;
